document.addEventListener('DOMContentLoaded', function () {
  // Exploded cell diagram — hover/focus/click a layer to update the annotation
  var layerData = {
    1: { title: "Composite Shell", body: "Impact- and puncture-resistant casing. Sealed against dust and moisture ingress for field and outdoor rack use." },
    2: { title: "Cathode Current Collector", body: "Aluminum foil that carries current out of the cathode with minimal resistive loss." },
    3: { title: "Graphene-Enhanced Cathode", body: "Graphene scaffolding increases electron mobility through the cathode, raising achievable discharge rate and energy density." },
    4: { title: "Ceramic-Coated Separator", body: "Prevents internal short circuits while tolerating higher temperatures than standard polymer separators." },
    5: { title: "Graphene Anode Lattice", body: "A graphene lattice replaces part of the graphite anode, cutting charge time and reducing lithium plating risk." },
    6: { title: "Anode Current Collector", body: "Copper foil carrying current from the anode to the cell terminal." }
  };

  document.querySelectorAll('[data-bx-cell-diagram]').forEach(function (diagram) {
    var layers = diagram.querySelectorAll('.bx-layer');
    var note = diagram.querySelector('.bx-layer-note');
    if (!note) return;
    function setNote(id) {
      var d = layerData[id];
      if (!d) return;
      note.innerHTML = '<strong>' + d.title + '</strong>' + d.body;
      layers.forEach(function (l) { l.classList.toggle('is-active', l.dataset.l === id); });
    }
    layers.forEach(function (l) {
      l.addEventListener('mouseenter', function () { setNote(l.dataset.l); });
      l.addEventListener('focus', function () { setNote(l.dataset.l); });
      l.addEventListener('click', function () { setNote(l.dataset.l); });
    });
  });

  // Reveal on scroll
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.bx-reveal');
  if (!prefersReduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bx-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('bx-in'); });
  }
});